import { HTTPClientCaches, IHTTPCache } from '@innerhive-internal/innerhive-api-client';
import { ILogger } from './ILogger';

interface ICacheStorage {
    open(cacheName: string): Promise<Pick<Cache, 'match' | 'put'>>;
}

// HTTPClient can fail a request on a cache failure, even one the api answered.
export class FailSafeHTTPClientCaches implements HTTPClientCaches {
    constructor(private cacheStorage: ICacheStorage, private log: ILogger) {}

    private report = (operation: keyof HTTPClientCaches | keyof IHTTPCache, error: unknown) => {
        this.log.error(new Error(`Offline cache ${operation} failed: ${error}`));
    };

    open = async (cacheName: string): Promise<IHTTPCache | undefined> => {
        let cache: Pick<Cache, 'match' | 'put'>;
        try {
            cache = await this.cacheStorage.open(cacheName);
        } catch (error) {
            this.report('open', error);
            return undefined;
        }

        return {
            match: async (request, options) => {
                try {
                    return await cache.match(request, options);
                } catch (error) {
                    this.report('match', error);
                    return undefined;
                }
            },
            put: async (request, response) => {
                try {
                    await cache.put(request, response);
                } catch (error) {
                    this.report('put', error);
                }
            }
        };
    };
}
